const bucketFor = ({ buckets, item, getValue }) =>
  buckets.find((bucket) => bucket.matcher(getValue(item)))

const startValue = (bucket, item, getValue) => {
  if (bucket) {
    if (typeof bucket.start === 'function') {
      return bucket.start(getValue(item))
    }
    return bucket.start
  }
  return ''
}

const newBucketValue = (val, bucket) => ({
  bucket,
  startValue: val,
  items: [],
})

const addToBucket = ({ output, bucket, item, getValue }) => {
  const val = startValue(bucket, item, getValue)
  const prevValue = output[val] || newBucketValue(val, bucket)
  return {
    ...output,
    [val]: {
      ...prevValue,
      items: prevValue.items.concat(item),
    },
  }
}

const defaultValueGetter = (item) => item.value

const bucketize = ({ buckets, data, getValue = defaultValueGetter }) =>
  data.reduce(
    (output, item) =>
      addToBucket({
        output,
        item,
        getValue,
        bucket: bucketFor({ buckets, item, getValue }),
      }),
    {}
  )

export default bucketize
